/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Link_PricingInputs */

const en_directory_footer_link_pricing = /** @type {(inputs: Directory_Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

const zh_directory_footer_link_pricing = /** @type {(inputs: Directory_Footer_Link_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Directory_Footer_Link_PricingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_link_pricing = /** @type {((inputs?: Directory_Footer_Link_PricingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Link_PricingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_link_pricing(inputs)
	return zh_directory_footer_link_pricing(inputs)
});
export { directory_footer_link_pricing as "directory.footer.link_pricing" }